// Theme code - receives messages and fires Kameleoon goals
(function() {
    // Track processed goals to prevent duplicates on main window level
    const processedGoals = new Set();
    
    // Listen for messages from Customer Events
    window.addEventListener('message', function(event) {
    // Only process kameleoon goal messages
    if (!event.data || !event.data.type) return;
    
    // Handle goal messages
    if (event.data.type === 'kameleoon_goal') {
        // Check if Kameleoon is available
        if (!window.Kameleoon?.API?.Goals) {
        console.log('[Kameleoon] API not ready, goal not fired:', event.data);
        return;
        }
        
        // Create unique key for this goal event
        const goalKey = `${event.data.goalName}_${event.data.productId || event.data.orderId || 'unknown'}`;
        
        // Check if already processed (in case of duplicate messages)
        if (processedGoals.has(goalKey)) {
        console.log('[Kameleoon] Goal already processed:', goalKey);
        return;
        }
        
        // For AddtoCart, check sessionStorage as additional safety
        if (event.data.goalName === 'AddtoCart' && event.data.productId) {
        const sessionKey = `atc_main_${event.data.productId}`;
        if (sessionStorage.getItem(sessionKey)) {
            console.log('[Kameleoon] AddtoCart already fired for product:', event.data.productId);
            return;
        }
        sessionStorage.setItem(sessionKey, Date.now().toString());
        }
        
        // Mark as processed
        processedGoals.add(goalKey);
        
        // Fire the Kameleoon goal
        try {
        if (event.data.revenue > 0) {
            window.Kameleoon.API.Goals.processConversion(event.data.goalId, event.data.revenue);
            console.log('[Kameleoon] Goal fired:', event.data.goalName, 'ID:', event.data.goalId, 'Revenue:', event.data.revenue);
        } else {
            window.Kameleoon.API.Goals.processConversion(event.data.goalId);
            console.log('[Kameleoon] Goal fired:', event.data.goalName, 'ID:', event.data.goalId);
        }
        } catch (error) {
        console.error('[Kameleoon] Error firing goal:', error);
        }
    }
    
    // Handle clear ATC message
    if (event.data.type === 'kameleoon_clear_atc') {
        console.log('[Kameleoon] Clearing ATC tracking after purchase');
        
        // Clear all ATC entries from sessionStorage
        const keysToRemove = [];
        for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && (key.startsWith('atc_main_') || key.startsWith('atc_'))) {
            keysToRemove.push(key);
        }
        }
        keysToRemove.forEach(key => sessionStorage.removeItem(key));
        
        // Clear memory tracking
        processedGoals.clear();
        
        console.log('[Kameleoon] Cleared', keysToRemove.length, 'ATC tracking entries');
    }
    });
    
    // Debug: Log Kameleoon availability on load
    window.addEventListener('load', function() {
    if (window.Kameleoon?.API?.Goals) {
        console.log('[Kameleoon] API ready on page load');
    } else {
        console.log('[Kameleoon] API not available on page load');
    }
    });
})();
